import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { mergeParams } from "../../../helpers/helpers";
import ijws from "../../../services/ijws";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const [usuarios, setUsuarios] = useState([]);
  const [filtros, setFiltros] = useState(
    mergeParams({ nome: "", email: "" }, location)
  );
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (filtros.nome || filtros.email) {
      carregar();
    }
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    ijws
      .get("admin/usuarios/listar", filtrosEnviar)
      .then((res) => {
        setUsuarios(res);
        setCarregando(false);
      })
      .catch((err) => {
        console.log("err", err);
        notification("error", "Erro ao listar os usuários");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome do usuário",
        type: "text",
        space: 6,
        value: filtros.nome,
      },
      validos: {
        label: "Email",
        type: "text",
        space: 6,
        value: filtros.email,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Usuários",
    onLineClick: (id) => history.push(`/app/usuario-ij/${id}`),
    key: "id",

    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Email",
        name: "email",
      },
    ],
    array: usuarios,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
